'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _gridActions = require('./gridActions');

var _gridUtils = require('./gridUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RESIZE_UPDATE_RATE = 300;

var mapStateToProps = function mapStateToProps(state) {
    return {
        gridSize: state.getIn(['app', 'gridSize'])
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        updateGridSize: function updateGridSize(size, name) {
            return dispatch((0, _gridActions.setGridSize)(size, name));
        }
    };
};

var GridSizeManager = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(GridSizeManager, _React$Component);

    function GridSizeManager() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, GridSizeManager);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GridSizeManager.__proto__ || Object.getPrototypeOf(GridSizeManager)).call.apply(_ref, [this].concat(args))), _this), _this.setBodyClass = function (bodyClass) {
            _this.removeBodyClass();
            document.body.classList.add(bodyClass);
            _this.currentBodyClass = bodyClass;
        }, _this.removeBodyClass = function () {
            if (_this.currentBodyClass) document.body.classList.remove(_this.currentBodyClass);
        }, _this.updateSize = function (windowWidth) {
            var _this$props = _this.props,
                gridSize = _this$props.gridSize,
                updateGridSize = _this$props.updateGridSize;

            var newGridSize = (0, _gridUtils.calculateGridSize)(windowWidth);

            if (newGridSize.name === gridSize.get('name')) return;

            updateGridSize(newGridSize.size, newGridSize.name);
        }, _this.handleResize = (0, _lodash.throttle)(function () {
            return _this.updateSize(window.innerWidth);
        }, RESIZE_UPDATE_RATE), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(GridSizeManager, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updateSize(window.innerWidth);
            window.addEventListener('resize', this.handleResize);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.gridSize === this.props.gridSize) return;

            var className = (0, _gridUtils.getGridSizeName)(nextProps.gridSize.get('name'));
            this.setBodyClass(className);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeBodyClass();
            window.removeEventListener('resize', this.handleResize);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.Children.only(this.props.children);
        }
    }]);

    return GridSizeManager;
}(_react2.default.Component)) || _class);


GridSizeManager.propTypes = {
    gridSize: _propTypes2.default.number,
    updateGridSize: _propTypes2.default.func,
    children: _propTypes2.default.element.isRequired
};

exports.default = GridSizeManager;


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/grid/GridSizeManager.js
// module id = 2123
// module chunks = 0